import React, { useState } from "react";
import axios from "axios";
import {
  Grid,
  makeStyles,
  TextField,
  Button,
  Typography,
  Box,
} from "@material-ui/core";
import LoadingIndicator from "./LoadingIndicator";
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },

  labelHeight: {
    fontSize: "0.7rem",
    padding: `${theme.spacing(1)}px 0px`,
  },

  dateTextField: {
    width: 100,
    margin: 0,
    "& .MuiInputBase-root": {
      padding: `0px ${theme.spacing(1)}px`,
      fontSize: "0.7rem",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: `0px ${theme.spacing(1)}px`,
    },
  },

  textField: {
    width: 200,
    margin: 0,
    "& .MuiInputBase-root": {
      padding: `4px ${theme.spacing(0)}px`,
      fontSize: "1rem",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: `0px ${theme.spacing(1)}px`,
    },
  },
  headerStyle: {
    marginLeft: "8px",
    margingBottom: "4px",
    marginTop: "4px",
    // backgroundColor: "#e3f2fd",
    backgroundColor: "#e2efd9",
  },
}));

const ReconcileSubmit = ({
  selectedRows,
  setSelectedRows,
  openPopup,
  setOpenPopup,
  reconciledBy,
  handleSearchFormSubmit,
  reconcileSubmitDataUrl,
  createNetInspectionApiClient,
  minDate,
  dateIsGreaterThanMinDate,
  setDisableEditPaymentBtn,
  setDisableReconcileButton,
  setDisableUnreconcileButton,
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [reconcillationDate, setReconcilliationDate] = useState(
    new Date().toISOString().substring(0, 10)
  );
  const [depositDate, setDepositDate] = useState("");

  const [reconcileNotes, setReconcileNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const handleNotesChange = (event) => {
    event.preventDefault();
    setReconcileNotes(event.target.value);
  };

  // const handleDepositDateChange = (event) => {
  //   event.preventDefault();
  // };

  const reconcilePostDataURL = reconcileSubmitDataUrl();

  const postReconcileData = async (dataToPost) => {
    try {
      setLoading(true);
      let baseUrl = `${reconcilePostDataURL}`;

      let response = await createNetInspectionApiClient().post(
        `${baseUrl}`,
        dataToPost
      );
      // set the local state data
      setLoading(false);

      enqueueSnackbar("Reconcile records submitted successfully!", {
        variant: "success",
      });

      //   console.log(response);
      // after successful post refresh the search fields data to "reconciled" and re-run the query
      clearData();
      setOpenPopup(false);
      setSelectedRows([]);
      setDisableEditPaymentBtn(true);
      setDisableReconcileButton(true);
      setDisableUnreconcileButton(true);
      handleSearchFormSubmit();
    } catch (err) {
      setLoading(false);
      enqueueSnackbar(
        (err && err.message) || "Oops! Something went wrong. Please try again!",
        { variant: "error" }
      );
    } finally {
      //   console.log("post reconcile completd");
    }
  };

  const clearData = (event) => {
    if (event) {
      event.preventDefault();
    }

    // clear values
    reconciledBy = "";
    setReconcileNotes("");
    setDepositDate("");
    setOpenPopup(false);
  };

  const convertDateStringToIsoString = (dateString) => {
    // console.log("Received date: ", dateString);

    var bits = dateString.split("-");

    // console.log("date bits 0, 1, 2: ", bits[0], bits[1], bits[2]);
    // below code adds 1 more month to ouput
    //return new Date(bits[0], bits[1], bits[2]).toISOString();
    // this one is correct
    return new Date(`${bits[0]} ${bits[1]} ${bits[2]} UTC`).toISOString();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (depositDate === "") {
      enqueueSnackbar("Deposit date cannot be empty", { variant: "error" });
      return;
    }

    if (isNaN(Date.parse(depositDate))) {
      enqueueSnackbar("Deposit date is invalid", { variant: "error" });
      return;
    }

    if (!dateIsGreaterThanMinDate(depositDate)) {
      enqueueSnackbar(
        `Deposit date cannot be less than ${minDate.toLocaleDateString()} `,
        { variant: "error" }
      );
      return;
    }

    let reconcileRecordData = [];
    selectedRows.map((row) => {
      // console.log("reconcile_id:", row.reconcile_Id);
      if (row.reconcile_id == null) {
        reconcileRecordData.push({
          reconciled_date: convertDateStringToIsoString(reconcillationDate),
          reconciled_by_user: reconciledBy,
          deposit_date:
            depositDate === "" ? "" : convertDateStringToIsoString(depositDate),
          reconcile_notes: reconcileNotes ?? "",
          inspection_id: row.inspection_id,
          inspection_type: row.inspection_type ?? "",
          payment_id: row.payment_id,
          payment_type: row.payment_type ?? "",
          payment_check_number: row.check_number ?? "",
          payment_check_payee: row.payer_name ?? "",
          payment_status: row.payment_status ?? "",
        });
      }
    });

    if (reconcileRecordData.length > 0) {
      // post data
      await postReconcileData(reconcileRecordData);
    }
    // console.log(JSON.stringify(reconcileRecordData));
  };

  let content;

  if (loading) {
    content = <LoadingIndicator />;
  } else {
    content = (
      <>
        <form>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            style={{ marginLeft: "10px" }}
          >
            <Grid item>
              <Typography className={classes.labelHeight}>Date</Typography>
              <TextField
                label=""
                name="reconcilliationDate"
                id="reconcilliationDate"
                type="date"
                disabled={true}
                // defaultValue="mm/dd/yyyy"
                fontSize="12"
                margin="none"
                //   inputProps={{
                //     min: "2022-01-01",
                //     style: { fontSize: 12, margin: 0 },
                //   }}
                InputLabelProps={{
                  shrink: true,
                  style: { fontSize: 14, margin: 8 },
                }}
                padding="0px 0px 0px 0px"
                className={classes.dateTextFieldField}
                value={reconcillationDate}
                onChange={(e) => {}}
              />
            </Grid>
            <Grid item>
              <Typography className={classes.labelHeight}>
                Deposit Date
              </Typography>
              <TextField
                label=""
                name="depositDate"
                id="depositDate"
                type="date"
                required={true}
                // defaultValue="mm/dd/yyyy"
                fontSize="12"
                margin="none"
                inputProps={{
                  max: new Date().toISOString().substring(0, 10),
                  // style: { fontSize: 12, margin: 0 },
                }}
                InputLabelProps={{
                  shrink: true,
                  style: { fontSize: 14, margin: 8 },
                }}
                padding="0px 0px 0px 0px"
                className={classes.dateTextFieldField}
                value={depositDate}
                onChange={(e) => {
                  setDepositDate(e.target.value);
                }}
                helperText={!depositDate ? "Deposit date is required" : ""}
                error={!depositDate}
              />
            </Grid>
            <Grid item>
              <Typography className={classes.labelHeight}>
                Reconciled By
              </Typography>
              <TextField
                label=""
                name="reconciled_by_user"
                id="reconciled_by_user"
                disabled={true}
                fontSize="12"
                margin="none"
                InputLabelProps={{
                  shrink: true,
                  style: { fontSize: 14, margin: 8 },
                }}
                padding="0px 0px 0px 0px"
                className={classes.textField}
                value={reconciledBy}
                onChange={(e) => {}}
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            style={{
              marginLeft: "10px",
            }}
          >
            <Grid item>
              <Typography className={classes.labelHeight}>Notes</Typography>
              <Box display="flex">
                <TextField
                  variant="outlined"
                  multiline={true}
                  minRows={10}
                  maxRows={10}
                  inputProps={{
                    maxLength: 1000,
                    border: "2px solid black!important",
                  }}
                  value={reconcileNotes}
                  style={{
                    width: "400px",
                  }}
                  onChange={(e) => {
                    handleNotesChange(e);
                  }}
                />
              </Box>
            </Grid>
          </Grid>
          <Grid container display="flex-end">
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                style={{
                  width: "80px",
                  height: "20px",
                  fontSize: "0.8rem",
                  padding: "10px 6px 8px 4px",
                  margin: "20px 10px 10px 6px",
                }}
                onClick={(e) => {
                  clearData(e);
                }}
              >
                Cancel
              </Button>
              <Button label="" style={{ backgroundColor: "white" }} />
              <Button label="" style={{ backgroundColor: "white" }} />
              <Button label="" style={{ backgroundColor: "white" }} />
              <Button
                variant="contained"
                color="primary"
                style={{
                  width: "80px",
                  height: "20px",
                  fontSize: "0.8rem",
                  padding: "10px 6px 8px 4px",
                  margin: "20px 10px 10px 16px",
                }}
                onClick={(e) => {
                  handleSubmit(e);
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </>
    );
  }

  return <> {content}</>;
};

export default ReconcileSubmit;
